import { useState } from "react";
import LegalLayout, { H2, P } from "../LegalLayout";
import api, { formatApiError } from "@/lib/api";

export default function Kontakt() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const { data } = await api.post("/contact", form);
      setDone(data.message);
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const inputCls =
    "w-full bg-black/40 border border-white/15 px-4 py-3.5 text-sm text-white placeholder:text-white/30 outline-none focus:border-gold transition-colors";

  return (
    <LegalLayout title="Kontakt">
      <P>
        Fragen zu Produkten, Bestellungen, Widerruf oder Anything MAZARO? Schreib uns — wir melden uns so schnell wie
        möglich.
      </P>

      <div className="border border-white/10 bg-panel p-5 mb-10" data-testid="contact-info-box">
        <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-gold mb-2">Direkter Draht</p>
        <p className="text-slate-300 text-sm">
          E-Mail:{" "}
          <a href="mailto:support@mazaro.de" className="text-gold underline underline-offset-4">
            support@mazaro.de
          </a>
        </p>
        <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-white/30 mt-2">
          Antwortzeit &amp; Telefon —{" "}
          <span className="text-goldlight">Platzhalter, im Impressum ergänzen</span>
        </p>
      </div>

      <H2>Kontaktformular</H2>
      {done ? (
        <div className="border border-gold/40 bg-gold/10 p-5 text-goldlight text-sm" data-testid="contact-success">
          {done}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <input
              data-testid="contact-name-input"
              required
              maxLength={100}
              className={inputCls}
              placeholder="Dein Name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
            <input
              data-testid="contact-email-input"
              type="email"
              required
              className={inputCls}
              placeholder="Deine E-Mail-Adresse"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
          </div>
          <textarea
            data-testid="contact-message-input"
            required
            maxLength={5000}
            rows={6}
            className={inputCls}
            placeholder="Deine Nachricht…"
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
          />
          {error && (
            <p data-testid="contact-error" className="text-red-400 text-sm">
              {error}
            </p>
          )}
          <button type="submit" disabled={busy} data-testid="contact-submit-button" className="btn-gold w-full sm:w-auto justify-center disabled:opacity-60">
            Nachricht senden
          </button>
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-white/30">
            Mit dem Absenden erklärst du dich mit der Verarbeitung gemäß Datenschutzerklärung einverstanden.
          </p>
        </form>
      )}
    </LegalLayout>
  );
}
